/* =========================================================
   WEAVIX — theme.js (no dependencies)
   Uses Shopify AJAX Cart API + Section Rendering API.
   ========================================================= */
(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};
  function tr(key, fallback, vars) {
    var s = S[key] || fallback;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{{ ' + k + ' }}').join(vars[k]).split('[[' + k + ']]').join(vars[k]); });
    return s;
  }
  T.tr = tr;
  T.routes = T.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = String(T.moneyFormat || 'LE {{amount}}').replace(/<[^>]*>/g, '');
    var n = Number(cents || 0) / 100;
    function num(dec, ts, ds) {
      var parts = n.toFixed(dec).split('.');
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? i + ds + parts[1] : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      return n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2);
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, ',', '.');
      }
    });
  }
  T.money = money; /* Smart search: more fields, synonyms + Arabic, view-all link */ (function(){var SYN={'pants':'trousers','pant':'trousers','jeans':'trousers','bottoms':'trousers','bottom':'trousers','sweatpants':'trousers','joggers':'trousers','tee':'shirt','tees':'shirt','tshirt':'shirt','t-shirt':'shirt','tops':'shirt','top':'shirt','shirts':'shirt','jumper':'sweater','pullover':'sweater','sweaters':'sweater','knit':'knitwear','hoody':'hoodie','hoodies':'hoodie','zipper':'zip','polos':'polo','grey':'gray','بنطلون':'trousers','بنطلونات':'trousers','بنطال':'trousers','سويت بانتس':'trousers','هودي':'hoodie','هوديز':'hoodie','سويت شيرت':'sweater','سويتشيرت':'sweater','سويتر':'sweater','بلوفر':'sweater','تريكو':'knitwear','قميص':'shirt','تيشيرت':'shirt','تيشرت':'shirt','تي شيرت':'shirt','بولو':'polo','هينلي':'henley','سوستة':'zip','سحاب':'zip','اسود':'black','بني':'brown','رمادي':'gray','كحلي':'navy','ازرق':'blue','ابيض':'white','زيتي':'olive','اخضر':'olive','نبيتي':'burgundy','واسع':'wide'};function norm(s){return String(s||'').toLowerCase().replace(/[أإآ]/g,'ا').replace(/ة/g,'ه').replace(/ى/g,'ي').replace(/\s+/g,' ').trim()}function smart(q){var w=norm(q).split(' '),o=[],i=0,ch=false;while(i<w.length){var two=w[i]+' '+(w[i+1]||'');if(w[i+1]&&SYN[two]){o.push(SYN[two]);i+=2;ch=true;continue}if(SYN[w[i]]){o.push(SYN[w[i]]);ch=true}else o.push(w[i]);i++}return ch?o.join(' '):String(q).trim()}T.smartQuery=smart;var timer,seq=0;document.addEventListener('input',function(e){var input=e.target;if(!input.matches||!input.matches('[data-predictive]'))return;e.stopImmediatePropagation();var out=document.querySelector('[data-predictive-results]');if(!out)return;clearTimeout(timer);var raw=input.value.trim();if(raw.length<2){out.innerHTML='';return}timer=setTimeout(function(){var q=smart(raw),my=++seq,all='/search?type=product&q='+encodeURIComponent(q);var url=T.routes.predictive+'.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,tag,vendor&resources[options][unavailable_products]=last';fetch(url).then(function(r){return r.json()}).then(function(j){if(my!==seq)return;var list=(j.resources&&j.resources.results&&j.resources.results.products)||[];if(!list.length){out.innerHTML='<p class="muted" style="grid-column:1/-1">No results for “'+esc(raw)+'”. Try Hoodie, Henley, Polo or Trousers.</p>';return}out.innerHTML=list.map(function(p){var img=p.image||(p.featured_image&&p.featured_image.url);return '<a class="sr-item" href="'+esc(p.url)+'"><img src="'+esc(sized(img,300))+'" alt="" loading="lazy" width="300" height="375"><b>'+esc(p.title)+'</b><span class="muted">'+money(Math.round(parseFloat(p.price)*100))+'</span></a>'}).join('')+'<a class="btn btn--ink btn--block" data-sr-all href="'+esc(all)+'" style="grid-column:1/-1;margin-top:8px">View all results →</a>';fetch(all).then(function(r){return r.text()}).then(function(h){if(my!==seq)return;var m=h.match(/(\d+)\s+results?/),b=out.querySelector('[data-sr-all]');if(m&&b)b.textContent='View all '+m[1]+' results →'}).catch(function(){})}).catch(function(){})},220)},true);document.addEventListener('submit',function(e){var f=e.target;if(!f.querySelector)return;var i=f.querySelector('input[name=q]');if(!i||!/\/search/.test(f.getAttribute('action')||''))return;i.value=smart(i.value)},true)})();
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; if (url.indexOf('data:') === 0) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- API (Shopify by default; the preview swaps in a mock) ---------- */
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong'); return j; }); });
  }
  var api = window.themePreviewApi || {
    add: function (items) {
      return postJSON(T.routes.cartAdd + '.js', { items: items, sections: 'cart-drawer', sections_url: location.pathname })
        .then(function (j) { return { html: j.sections && j.sections['cart-drawer'] }; });
    },
    change: function (line, quantity) {
      return postJSON(T.routes.cartChange + '.js', { line: line, quantity: quantity, sections: 'cart-drawer', sections_url: location.pathname })
        .then(function (j) { return { html: j.sections && j.sections['cart-drawer'] }; });
    },
    product: function (url) {
      return fetch(url.split('?')[0] + '.js').then(function (r) { if (!r.ok) throw new Error('Product not found'); return r.json(); });
    },
    predictive: function (q) {
      return fetch(T.routes.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var list = (j.resources && j.resources.results && j.resources.results.products) || [];
          return list.map(function (p) { return { title: p.title, url: p.url, image: p.image || (p.featured_image && p.featured_image.url), price: Math.round(parseFloat(p.price) * 100) }; });
        });
    }
  };

  /* ---------- Overlays ---------- */
  var openEl = null, lastFocus = null;
  function scrim(on) { var s = $('[data-scrim]'); if (s) s.classList.toggle('is-open', on); document.body.classList.toggle('lock', on); }
  function open(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    if (openEl && openEl !== el) close(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    scrim(true);
    openEl = el;
    setTimeout(function () {
      var f = el.querySelector('input[type=search], input[type=email]:not([hidden]), [data-close], [data-pop-close], button');
      if (f && window.matchMedia('(hover:hover)').matches) f.focus({ preventScroll: true });
      else if (f && f.type === 'search') f.focus({ preventScroll: true });
    }, 80);
    return true;
  }
  function close(keepScrim) {
    if (!openEl) return;
    if (openEl.hasAttribute('data-popup')) markPopupSeen();
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden', 'true');
    openEl = null;
    if (!keepScrim) {
      scrim(false);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }
  T.open = open; T.close = close;

  var toastTimer;
  function toast(text, plain) {
    var t = $('[data-toast]'); if (!t) return;
    $('[data-toast-text]', t).textContent = text;
    var vb = t.querySelector('button'); if (vb) vb.hidden = !!plain;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }
  T.toast = toast;

  /* ---------- Cart ---------- */
  function renderCart(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-inner]');
    var cur = $('[data-cart-inner]');
    if (next && cur) cur.replaceWith(next);
    var count = next ? parseInt(next.getAttribute('data-count'), 10) || 0 : 0;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
  }
  T.renderCart = renderCart;
  function addItems(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return api.add(items).then(function (res) {
      renderCart(res.html);
      open('CartDrawer');
    }).catch(function (err) {
      toast(err.message);
    }).then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(line, qty) {
    var inner = $('[data-cart-inner]');
    var drawer = $('#CartDrawer');
    if (drawer) drawer.classList.add('is-updating');
    api.change(line, Math.max(0, qty)).then(function (res) { renderCart(res.html); })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (drawer) drawer.classList.remove('is-updating'); });
  }

  /* ---------- Quick add (bottom sheet on mobile) ---------- */
  var qa = null;
  function quickAdd(url, btn) {
    if (btn) btn.classList.add('is-loading');
    api.product(url).then(function (p) {
      if (p.variants.length === 1) return addItems([{ id: p.variants[0].id, quantity: 1 }], btn);
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      qa = { p: p, sel: first.options.slice(), url: url };
      drawQA();
      open('QuickAdd');
    }).catch(function () { location.href = url; })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function qaVariant() {
    return qa.p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === qa.sel[i]; }); })[0];
  }
  function drawQA() {
    var p = qa.p, v = qaVariant();
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]);
    var h = '<div class="qa__head"><img src="' + esc(sized(img, 240)) + '" alt="" width="72" height="90">' +
      '<div><p class="qa__name">' + esc(p.title) + '</p><div class="price"><span class="price__now">' + money(v ? v.price : p.price) + '</span>' +
      (v && v.compare_at_price > v.price ? '<s class="price__was">' + money(v.compare_at_price) + '</s>' : '') + '</div></div></div>';
    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = typeof opt === 'string' ? Array.from(new Set(p.variants.map(function (x) { return x.options[i]; }))) : opt.values;
      var isColor = /^colou?r$/i.test(name);
      h += '<div class="qa__opt"><div class="qa__optname"><span class="opt__label" style="margin:0">' + esc(name) + ': <span>' + esc(qa.sel[i]) + '</span></span>' +
        (/^size$/i.test(name) && document.getElementById('SizeGuide') ? '<button type="button" data-open="SizeGuide">' + tr('size_guide', 'Size guide') + '</button>' : '') + '</div>' +
        '<div class="pills' + (isColor ? ' pills--color' : values.length > 5 ? ' pills--text' : '') + '">';
      values.forEach(function (val) {
        var trial = qa.sel.slice(); trial[i] = val;
        var ok = p.variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === trial[k]; }); });
        h += '<label class="pill' + (ok ? '' : ' is-unavailable') + '"><input type="radio" name="qa-' + i + '" value="' + esc(val) + '" data-qa-opt="' + i + '"' + (qa.sel[i] === val ? ' checked' : '') + '>' +
          '<span' + (isColor ? ' style="background:' + esc(val.toLowerCase().replace(/\s+/g, '')) + '"' : '') + ' title="' + esc(val) + '">' + esc(val) + '</span></label>';
      });
      h += '</div></div>';
    });
    var can = v && v.available;
    h += '<div style="display:grid;gap:8px;margin-top:18px">' +
      '<button type="button" class="btn btn--ink btn--block" data-qa-add' + (can ? '' : ' disabled') + '>' + (v ? (can ? tr('add_to_bag', 'Add to bag') + ' · ' + money(v.price) : tr('sold_out', 'Sold out')) : tr('unavailable', 'Unavailable')) + '</button>' +
      '<button type="button" class="btn btn--accent btn--block" data-qa-buy' + (can ? '' : ' disabled') + '>' + tr('buy_now', 'Buy now') + '</button>' +
      '<a class="link" style="justify-self:center;margin-top:6px" href="' + esc(qa.url) + '">' + tr('view_details', 'View full details') + '</a></div>';
    $('[data-quick-add-body]').innerHTML = h;
  }

  /* ---------- Product page ---------- */
  function initPDP(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var dataEl = $('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var atc = form ? $('[data-atc]', form) : null;
    var sticky = $('[data-sticky-atc]');

    function selected() {
      var o = [];
      $$('[data-option]:checked', root).forEach(function (i) { o[+i.dataset.option] = i.value; });
      return o;
    }
    function markAvailability(o) {
      $$('[data-option]', root).forEach(function (input) {
        var i = +input.dataset.option, trial = o.slice(); trial[i] = input.value;
        var ok = variants.some(function (v) { return v.available && v.options.every(function (x, k) { return trial[k] === undefined || x === trial[k]; }); });
        input.closest('.pill').classList.toggle('is-unavailable', !ok);
      });
    }
    function update() {
      var o = selected();
      $$('[data-option-label]', root).forEach(function (l) { l.textContent = o[+l.dataset.optionLabel] || ''; });
      markAvailability(o);
      var v = variants.filter(function (x) { return x.options.every(function (y, i) { return y === o[i]; }); })[0];
      var label = !v ? tr('unavailable', 'Unavailable') : v.available ? tr('add_to_bag', 'Add to bag') : tr('sold_out', 'Sold out');
      if (atc) { atc.disabled = !(v && v.available); $('[data-atc-text]', atc).textContent = label; }
      if (sticky) {
        var sb = $('[data-sticky-submit]', sticky); sb.disabled = !(v && v.available); sb.textContent = label;
      }
      syncNotify(v);
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var price = $('[data-price]', root);
      if (price) {
        price.classList.toggle('price--sale', v.compare > v.price);
        price.innerHTML = '<span class="price__now">' + money(v.price) + '</span>' + (v.compare > v.price ? '<s class="price__was">' + money(v.compare) + '</s>' : '');
      }
      var save = $('[data-save]', root);
      if (save) { save.hidden = !(v.compare > v.price); save.textContent = tr('save', 'Save {{ amount }}', { amount: money(v.compare - v.price) }); }
      var stock = $('[data-stock]', root);
      if (stock) {
        stock.hidden = !v.available;
        var low = v.qty !== null && v.qty > 0 && v.qty <= 5;
        stock.classList.toggle('stock--low', low);
        stock.textContent = low ? tr('only_left', 'Only {{ count }} left', { count: v.qty }) : tr('in_stock', 'In stock, ready to ship');
      }
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = money(v.price);
        var sv = $('[data-sticky-variant]', sticky); if (sv) sv.textContent = v.title;
      }
      if (root.dataset.url && window.history.replaceState) history.replaceState(null, '', root.dataset.url + '?variant=' + v.id);
      if (v.media) goToMedia(v.media);
    }
    function syncNotify(v) {
      var n = $('[data-notify]', root); if (!n) return;
      var show = !!v && !v.available;
      n.hidden = !show;
      var vi = $('[data-notify-variant]', n); if (vi && v) vi.value = v.title;
      if (show) { var fl = $('[data-wa-fields]', n), dn = $('[data-wa-done]', n); if (fl) fl.hidden = false; if (dn) dn.hidden = true; }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) update(); });
    (function () {
      var o = selected();
      syncNotify(variants.filter(function (x) { return x.options.every(function (y, i) { return y === o[i]; }); })[0]);
    })();
    if (variants.length) markAvailability(selected());

    // Gallery
    var track = $('[data-gallery-track]', root);
    function goToMedia(id) {
      var slide = track && $('[data-media-id="' + id + '"]', track);
      if (!slide || window.matchMedia('(min-width:990px)').matches) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    if (track) {
      var dots = $$('.gallery__dots i', root), idx = $('[data-gallery-index]', root);
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        if (idx) idx.textContent = i + 1;
      }, { passive: true });
    }

    // Sticky add to cart
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-submit]', sticky).tabIndex = show ? 0 : -1;
      }).observe(atc);
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = parseInt(form.querySelector('[name=quantity]').value, 10) || 1;
      addItems([{ id: +idInput.value, quantity: q }], atc);
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecs() {
    $$('[data-recommendations]').forEach(function (el) {
      if (!el.dataset.url || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recommendations]');
        if (d && d.innerHTML.trim()) el.innerHTML = d.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- Countdown ---------- */
  var cdTimer = null;
  function initCountdowns() {
    if (cdTimer || !$('[data-countdown]')) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      $$('[data-countdown]').forEach(function (el) {
        var target = Date.parse(el.dataset.countdown);
        if (isNaN(target)) { el.hidden = true; return; }
        var d = Math.max(0, target - Date.now());
        if (d === 0 && el.dataset.live) $('[data-cd-label]', el).textContent = el.dataset.live;
        $('[data-d]', el).textContent = pad(Math.floor(d / 864e5));
        $('[data-h]', el).textContent = pad(Math.floor(d / 36e5) % 24);
        $('[data-m]', el).textContent = pad(Math.floor(d / 6e4) % 60);
        $('[data-s]', el).textContent = pad(Math.floor(d / 1e3) % 60);
      });
    }
    tick(); cdTimer = setInterval(tick, 1000);
  }

  /* ---------- Welcome popup ---------- */
  var POP_KEY = 'weavix-popup-seen';
  function markPopupSeen() { try { localStorage.setItem(POP_KEY, String(Date.now())); sessionStorage.setItem(POP_KEY, '1'); } catch (e) {} }
  function initPopup() {
    var pop = $('[data-popup]');
    if (!pop) return;
    if (pop.hasAttribute('data-design-mode')) return; // opened from the theme editor instead
    var freq = pop.dataset.frequency || 'days', signed = false, seen = 0, inSession = false;
    try {
      signed = localStorage.getItem(POP_KEY + '-joined') === '1';
      seen = parseInt(localStorage.getItem(POP_KEY), 10) || 0;
      inSession = sessionStorage.getItem(POP_KEY) === '1';
    } catch (e) {}
    if (signed && freq !== 'always') return;
    if (freq === 'session' && inSession) return;
    if (freq === 'days') {
      var days = parseInt(pop.dataset.days, 10) || 14;
      if (seen && Date.now() - seen < days * 864e5) return;
    }
    var delay = (parseInt(pop.dataset.delay, 10) || 0) * 1000;
    var show = function () { setTimeout(function () { if (!openEl) open('WelcomePopup'); }, delay); };
    if ((pop.dataset.trigger || 'land') === 'land') return show();
    // "engaged": wait until the visitor scrolls halfway down, or opens a second page this visit
    var views = 1;
    try { views = (parseInt(sessionStorage.getItem('weavix-pv'), 10) || 0) + 1; sessionStorage.setItem('weavix-pv', String(views)); } catch (e) {}
    if (views >= 2) return show();
    var fired = false;
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (!fired && max > 0 && window.scrollY / max >= 0.5) {
        fired = true; window.removeEventListener('scroll', onScroll); delay = 0; show();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  T.markPopupSeen = markPopupSeen;

  /* ---------- WhatsApp early-access form ---------- */
  function normalizePhone(raw, cc) {
    var d = String(raw || '').replace(/[^\d+]/g, '');
    var ccDigits = String(cc || '+20').replace(/\D/g, '');
    if (d.indexOf('+') === 0) d = d.slice(1);
    else if (d.indexOf('00') === 0) d = d.slice(2);
    else if (d.indexOf(ccDigits) === 0 && d.length > 10) { /* already has country code */ }
    else d = ccDigits + d.replace(/^0+/, '');
    d = d.replace(/\D/g, '');
    if (ccDigits === '20' && d.indexOf('20') === 0) return /^20(10|11|12|15)\d{8}$/.test(d) ? '+' + d : null;
    return d.length >= 9 && d.length <= 15 ? '+' + d : null;
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-wa-form]')) return;
    e.preventDefault();
    var input = f.querySelector('[name=whatsapp]'), err = f.querySelector('[data-wa-error]');
    var phone = normalizePhone(input.value, input.getAttribute('data-cc'));
    if (!phone) {
      err.textContent = tr('wa_invalid', 'Enter a valid WhatsApp number, like 10 1234 5678.');
      err.hidden = false; input.focus(); return;
    }
    err.hidden = true;
    var nameEl = f.querySelector('[name=name]'), name = nameEl ? (nameEl.value || '').trim() : '';
    var btn = f.querySelector('[type=submit]');
    var done = function () {
      f.querySelector('[data-wa-fields]').hidden = true;
      f.querySelector('[data-wa-done]').hidden = false;
      if (f.getAttribute('data-source') !== 'back-in-stock') {
        markPopupSeen();
        try { localStorage.setItem(POP_KEY + '-joined', '1'); } catch (x) {}
      }
    };
    var mode = f.getAttribute('data-mode');
    if (mode === 'sheet') {
      btn.classList.add('is-loading');
      var body = new URLSearchParams();
      Array.prototype.forEach.call(f.querySelectorAll('input[name]'), function (i) { if (i.name !== 'whatsapp') body.append(i.name, i.value); });
      body.set('whatsapp', phone); body.set('page', location.pathname);
      body.set('source', f.getAttribute('data-source') || (f.closest('[data-popup]') ? 'early-access-popup' : 'early-access'));
      fetch(f.getAttribute('data-endpoint'), { method: 'POST', mode: 'no-cors', body: body })
        .then(done, function () { err.textContent = tr('wa_error', 'Couldn’t save your number. Check your connection and try again.'); err.hidden = false; })
        .then(function () { btn.classList.remove('is-loading'); });
    } else if (mode === 'chat') {
      var extra = ['product', 'variant'].map(function (k) { var i = f.querySelector('[name=' + k + ']'); return i && i.value ? '\n' + k.charAt(0).toUpperCase() + k.slice(1) + ': ' + i.value : ''; }).join('');
      var msg = (f.getAttribute('data-message') || 'Add me to the early access list.') + extra + (name ? '\nName: ' + name : '') + '\nWhatsApp: ' + phone;
      window.open('https://wa.me/' + f.getAttribute('data-store-wa') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      done();
    } else {
      done(); // preview / demo
    }
  });
  T.initPDP = initPDP;
  T.initAutoRail = initAutoRail;
  T.initReveal = initReveal;
  T.initBento = initBento;
  function initSlides() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-slides]'), function (box) {
      if (box._slides) return;
      var slides = box.querySelectorAll('.story__slide');
      if (slides.length < 2) return;
      var DUR = 5000, i = 0;
      var bar = document.createElement('div');
      bar.className = 'slides-bar'; bar.setAttribute('aria-hidden', 'true');
      for (var k = 0; k < slides.length; k++) bar.appendChild(document.createElement('span'));
      box.appendChild(bar);
      var segs = bar.children;
      function paint() {
        for (var k = 0; k < segs.length; k++) {
          segs[k].classList.remove('is-on');
          segs[k].classList.toggle('is-done', k < i);
        }
        void segs[i].offsetWidth;
        segs[i].classList.add('is-on');
      }
      paint();
      box._slides = setInterval(function () {
        if (!box.isConnected) { clearInterval(box._slides); return; }
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
        paint();
      }, DUR);
    });
  }
  T.initSlides = initSlides;
  T.initBrandMoment = initBrandMoment;
  T.initCountdowns = initCountdowns;

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = $('[data-predictive]'), out = $('[data-predictive-results]');
    if (!input || !out) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        api.predictive(q).then(function (list) {
          if (!list.length) { out.innerHTML = '<p class="muted" style="grid-column:1/-1">' + tr('no_results', 'No results for “{{ terms }}”.', { terms: esc(q) }) + '</p>'; return; }
          out.innerHTML = list.map(function (p) {
            return '<a class="sr-item" href="' + esc(p.url) + '"><img src="' + esc(sized(p.image, 300)) + '" alt="" loading="lazy" width="300" height="375"><b>' + esc(p.title) + '</b><span class="muted">' + money(p.price) + '</span></a>';
          }).join('');
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open]'))) {
      if (open(t.getAttribute('data-open'))) e.preventDefault();
      return;
    }
    if ((t = e.target.closest('[data-pop-close]'))) {
      if (t.tagName !== 'A') e.preventDefault();
      close();
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('[data-scrim]')) { close(); return; }
    if ((t = e.target.closest('[data-quick-add]'))) { e.preventDefault(); quickAdd(t.getAttribute('data-quick-add'), t); return; }
    if ((t = e.target.closest('[data-qa-add]'))) {
      var v = qaVariant(); if (v) addItems([{ id: v.id, quantity: 1 }], t); return;
    }
    if ((t = e.target.closest('[data-qa-buy]'))) { var bv = qaVariant(); if (bv) { var bb = t; bb.classList.add('is-loading'); window.addEventListener('pageshow', function () { bb.classList.remove('is-loading'); }, { once: true }); fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: bv.id, quantity: 1 }) }).then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message); }); window.location.href = '/checkout'; }).catch(function (err) { bb.classList.remove('is-loading'); alert(err.message); }); } return; }
    if ((t = e.target.closest('[data-line-qty]'))) {
      var line = +t.closest('[data-line]').getAttribute('data-line');
      changeLine(line, parseInt(t.getAttribute('data-line-qty'), 10));
      return;
    }
    if ((t = e.target.closest('[data-qty-step]'))) {
      var inp = t.parentNode.querySelector('input');
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(t.getAttribute('data-qty-step'), 10));
      return;
    }
    if ((t = e.target.closest('[data-tab]'))) {
      var rootEl = t.closest('[data-tabs-root]'), id = t.getAttribute('data-tab');
      $$('[data-tab]', rootEl).forEach(function (b) { b.setAttribute('aria-selected', b === t ? 'true' : 'false'); });
      $$('[data-panel]', rootEl).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      return;
    }
    if ((t = e.target.closest('[data-sticky-submit]'))) {
      var f = $('[data-product-form]');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); }
      return;
    }
    if ((t = e.target.closest('[data-rail]'))) {
      var track = t.closest('section').querySelector('[data-rail-track]');
      if (track) {
        if (track._pauseFor) track._pauseFor(2500);
        track.scrollBy({ left: parseInt(t.getAttribute('data-rail'), 10) * track.clientWidth * 0.85, behavior: 'smooth' });
      }
      return;
    }
    if ((t = e.target.closest('[data-ctl-add]'))) {
      var items = [], main = $('[data-variant-id]'), atcBtn = $('[data-atc]');
      if (main && atcBtn && !atcBtn.disabled) items.push({ id: +main.value, quantity: 1 });
      $$('[data-ctl-item]', t.closest('[data-ctl]')).forEach(function (row) {
        var inc = row.querySelector('[data-ctl-include]'), v = row.querySelector('[data-ctl-variant]');
        if (inc && inc.checked && v && v.value) items.push({ id: +v.value, quantity: 1 });
      });
      if (!items.length) { toast(tr('pick_items', 'Pick at least one piece'), true); return; }
      addItems(items, t);
      return;
    }
    if ((t = e.target.closest('[data-fit-select]'))) {
      var sz = t.getAttribute('data-size'), pd = $('[data-pdp]');
      var input = pd && $$('[data-option]', pd).filter(function (x) { return x.value === sz; })[0];
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      close(); toast(tr('size_selected', 'Size {{ size }} selected', { size: sz }), true);
      return;
    }
    if ((t = e.target.closest('[data-theme-toggle]'))) {
      var root = document.documentElement, dark = root.getAttribute('data-wx-theme') !== 'dark';
      root.classList.add('wx-theme-anim');
      if (dark) root.setAttribute('data-wx-theme', 'dark'); else root.removeAttribute('data-wx-theme');
      try { localStorage.setItem('weavix-theme', dark ? 'dark' : 'light'); } catch (x) {}
      syncThemeToggle();
    initBrandMoment();
      setTimeout(function () { root.classList.remove('wx-theme-anim'); }, 400);
      return;
    }
    if (e.target.closest('[data-back-top]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    if ((t = e.target.closest('[data-copy]'))) {
      var code = t.getAttribute('data-copy');
      var done = function () { t.textContent = 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () { selectText(t.previousElementSibling); });
      else selectText(t.previousElementSibling);
    }
  });
  function selectText(el) { if (!el) return; var r = document.createRange(); r.selectNodeContents(el); var s = getSelection(); s.removeAllRanges(); s.addRange(r); }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-fit-pref]')) { sizeFinder(t.closest('[data-fit-finder]')); return; }
    if (t.matches('[data-qa-opt]')) { qa.sel[+t.getAttribute('data-qa-opt')] = t.value; drawQA(); return; }
    if (t.matches('[data-line-input]')) { changeLine(+t.closest('[data-line]').getAttribute('data-line'), parseInt(t.value, 10) || 0); return; }
    if (t.matches('[data-sort]')) {
      var u = new URL(location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page'); location.href = u.toString();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) close(); });

  /* ---------- Size finder ---------- */
  // Each size: [max height cm, max weight kg]. Above the last row = biggest size.
  var FIT = [['S', 170, 62], ['M', 178, 72], ['L', 184, 82], ['XL', 190, 92], ['XXL', 999, 999]];
  function sizeFinder(root) {
    var h = parseFloat($('[data-fit-h]', root).value), w = parseFloat($('[data-fit-w]', root).value);
    var prefEl = $('[data-fit-pref]:checked', root), pref = prefEl ? parseInt(prefEl.value, 10) : 0;
    var out = $('[data-fit-result]', root), hint = $('[data-fit-hint]', root);
    if (!(h >= 140 && h <= 215 && w >= 40 && w <= 160)) {
      out.hidden = true; hint.hidden = false;
      hint.textContent = (h || w) ? tr('fit_range', 'Enter a height between 140 and 215 cm and a weight between 40 and 160 kg.') : tr('fit_hint', 'Your result shows up here as you type.');
      return;
    }
    function idx(v, col) { for (var i = 0; i < FIT.length; i++) if (v < FIT[i][col]) return i; return FIT.length - 1; }
    var hi = idx(h, 1), wi = idx(w, 2);
    var base = Math.abs(hi - wi) <= 1 ? Math.max(hi, wi) : Math.round((hi + wi) / 2);
    var i = Math.min(FIT.length - 1, Math.max(0, base + pref));
    var size = FIT[i][0];
    var note = pref < 0 ? tr('fit_closer', 'A closer fit than our oversized cut.') : pref > 0 ? tr('fit_baggy', 'One size up for an extra baggy look.') : tr('fit_designed', 'The relaxed, oversized fit we designed it for.');
    if (hi !== wi && pref === 0) note += ' ' + tr('fit_between', 'You’re between sizes, so size down for a closer fit.');
    $('[data-fit-size]', root).textContent = size;
    $('[data-fit-note]', root).textContent = note;
    var btn = $('[data-fit-select]', root);
    btn.setAttribute('data-size', size);
    var pdp = $('[data-pdp]');
    var has = pdp && $$('[data-option]', pdp).some(function (x) { return x.value === size; });
    btn.hidden = !has;
    btn.textContent = tr('fit_select', 'Select size {{ size }}', { size: size });
    out.hidden = false; hint.hidden = true;
    try { localStorage.setItem('weavix-fit', JSON.stringify({ h: h, w: w, p: pref })); } catch (e) {}
  }
  function initFitFinder() {
    $$('[data-fit-finder]').forEach(function (root) {
      try {
        var saved = JSON.parse(localStorage.getItem('weavix-fit') || 'null');
        if (saved) {
          $('[data-fit-h]', root).value = saved.h; $('[data-fit-w]', root).value = saved.w;
          var r = $('[data-fit-pref][value="' + saved.p + '"]', root); if (r) r.checked = true;
          sizeFinder(root);
        }
      } catch (e) {}
    });
  }
  document.addEventListener('input', function (e) {
    var root = e.target.closest && e.target.closest('[data-fit-finder]');
    if (root) sizeFinder(root);
  });

  /* ---------- Product photo zoom (desktop hover) ---------- */
  var zoomSlide = null;
  document.addEventListener('mousemove', function (e) {
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var slide = e.target.closest ? e.target.closest('.gallery__slide') : null;
    if (zoomSlide && zoomSlide !== slide) { zoomSlide.classList.remove('is-zoom'); zoomSlide = null; }
    if (!slide) return;
    var img = slide.querySelector('img'); if (!img) return;
    var r = slide.getBoundingClientRect();
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
    slide.classList.add('is-zoom'); zoomSlide = slide;
  });
  document.addEventListener('mouseleave', function () { if (zoomSlide) { zoomSlide.classList.remove('is-zoom'); zoomSlide = null; } });

  /* ---------- Auto-scrolling, endless strips (reviews) ---------- */
  function initAutoRail(track) {
    if (!track || track.dataset.autoReady) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    track.dataset.autoReady = '1';
    // Two extra copies so the strip can loop in both directions.
    for (var n = 0; n < 2; n++) cards.forEach(function (c) {
      var k = c.cloneNode(true);
      k.setAttribute('aria-hidden', 'true');
      k.removeAttribute('data-shopify-editor-block');
      $$('a,button,input,[tabindex]', k).forEach(function (f) { f.tabIndex = -1; });
      track.appendChild(k);
    });
    track.classList.add('is-auto');
    var setW = 0, pos = 0, last = 0, paused = false, resumeT;
    var speed = parseFloat(track.dataset.autoRail) || 80;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function measure() { setW = track.children[cards.length].offsetLeft - track.children[0].offsetLeft; }
    function wrap() {
      if (!setW) return;
      if (track.scrollLeft >= setW * 2) track.scrollLeft -= setW;
      else if (track.scrollLeft < setW * 0.25) track.scrollLeft += setW;
    }
    measure();
    track.scrollLeft = setW; pos = setW;
    function pause() { paused = true; clearTimeout(resumeT); }
    function resume(delay) { clearTimeout(resumeT); resumeT = setTimeout(function () { pos = track.scrollLeft; paused = false; }, delay); }
    track.addEventListener('pointerdown', pause);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('pointerup', function () { resume(1800); });
    track.addEventListener('touchend', function () { resume(1800); }, { passive: true });
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function () { resume(400); });
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', function () { resume(800); });
    track.addEventListener('wheel', function () { pause(); resume(1500); }, { passive: true });
    track.addEventListener('scroll', function () { wrap(); if (paused) pos = track.scrollLeft; }, { passive: true });
    window.addEventListener('resize', function () { var r = setW ? track.scrollLeft / setW : 1; measure(); track.scrollLeft = setW * r; pos = track.scrollLeft; });
    track._pauseFor = function (ms) { pause(); resume(ms); };
    if (still) return;
    function step(t) {
      requestAnimationFrame(step);
      var dt = last ? Math.min(64, t - last) : 16; last = t;
      if (paused || document.hidden) return;
      var box = track.getBoundingClientRect();
      if (box.bottom < 0 || box.top > window.innerHeight) return;
      pos += speed * dt / 1000;
      if (pos >= setW * 2) pos -= setW;
      track.scrollLeft = pos;
    }
    requestAnimationFrame(step);
  }

  /* ---------- Scroll reveal: rise from below, blur to sharp (replays both directions) ---------- */
  var REVEAL = '.shead, .grid > li, .rail > li, .cat, .bento__item, .fab__tile, .story__media, .story > div:last-child, .stat, .reviews, .faq > div:first-child, .acc, .news__inner > *, .foot__hero > *, .foot__cols, .coll-head, .active-filters, .pinfo > *, .empty-state, .page > *';
  var revealIO = null;
  function initReveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('js-reveal');
    if (!revealIO) revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.intersectionRatio >= 0.08) e.target.classList.add('is-in');
        else if (!e.isIntersecting) e.target.classList.remove('is-in');
      });
    }, { threshold: [0, 0.08], rootMargin: '0px 0px -6% 0px' });
    $$(REVEAL).forEach(function (el) {
      if (el.hasAttribute('data-reveal') || el.closest('.drawer, .sheet, .pop, [aria-hidden="true"]')) return;
      el.setAttribute('data-reveal', '');
      var sibs = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
      if (el.matches('.grid > li, .rail > li, .cat, .bento__item, .fab__tile, .stat, .acc')) el.style.setProperty('--rd', (sibs % 4) * 80 + 'ms');
      revealIO.observe(el);
    });
  }

  /* ---------- Bento tiles: arrow circle follows the cursor ---------- */
  function initBento() {
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    $$('[data-bento]').forEach(function (tile) {
      if (tile.dataset.bentoReady) return;
      tile.dataset.bentoReady = '1';
      var dot = tile.querySelector('.bento__cursor'), tx = 0, ty = 0, x = 0, y = 0, raf = 0, on = false;
      var st = 0;
      function tick() {
        var dx = tx - x, dy = ty - y;
        x += dx * 0.2; y += dy * 0.2;
        var v = Math.min(Math.hypot(dx, dy) / 140, 0.38);
        st += (v - st) * 0.25;
        tile.style.setProperty('--cx', x.toFixed(1) + 'px');
        tile.style.setProperty('--cy', y.toFixed(1) + 'px');
        if (dot) {
          if (Math.hypot(dx, dy) > 1) dot.style.setProperty('--ang', (Math.atan2(dy, dx) * 180 / Math.PI).toFixed(1) + 'deg');
          dot.style.setProperty('--sx', (1 + st).toFixed(3));
          dot.style.setProperty('--sy', (1 - st * 0.55).toFixed(3));
        }
        raf = on || Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5 || st > 0.01 ? requestAnimationFrame(tick) : 0;
      }
      tile.addEventListener('mouseenter', function (e) {
        var r = tile.getBoundingClientRect();
        x = tx = e.clientX - r.left; y = ty = e.clientY - r.top;
        on = true; tile.classList.add('is-cursor');
        if (!raf) raf = requestAnimationFrame(tick);
      });
      tile.addEventListener('mousemove', function (e) {
        var r = tile.getBoundingClientRect();
        tx = e.clientX - r.left; ty = e.clientY - r.top;
        if (!raf) raf = requestAnimationFrame(tick);
      });
      tile.addEventListener('mouseleave', function () { on = false; tile.classList.remove('is-cursor'); });
    });
  }

  /* ---------- Brand moment: play the logo animation each time it enters the screen ---------- */
  function initBrandMoment() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('[data-brand-moment]').forEach(function (el) {
      if (el.dataset.bmReady) return;
      el.dataset.bmReady = '1';
      el.classList.add('is-ready');
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.25) el.classList.add('is-play');
          else if (!e.isIntersecting) el.classList.remove('is-play');
        });
      }, { threshold: [0, 0.25] }).observe(el);
    });
  }

  /* ---------- Hero parallax ---------- */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function run() {
      ticking = false;
      $$('[data-parallax]').forEach(function (el) {
        var box = el.parentNode.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var y = Math.max(0, -box.top) * 0.3;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function syncThemeToggle() {
    var dark = document.documentElement.getAttribute('data-wx-theme') === 'dark';
    $$('[data-theme-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', dark ? 'true' : 'false');
      b.setAttribute('aria-label', dark ? tr('light_mode', 'Switch to light mode') : tr('dark_mode', 'Switch to dark mode'));
    });
    var m = document.querySelector('meta[name="theme-color"]');
    if (m) { if (!m.dataset.light) m.dataset.light = m.content; m.content = dark ? '#0E0E0D' : m.dataset.light; }
  }

  /* ---------- Init ---------- */
  function init() {
    initPDP($('[data-pdp]'));
    initRecs();
    initCountdowns();
    initSearch();
    initPopup();
    initParallax();
    initFitFinder();
    $$('[data-auto-rail]').forEach(initAutoRail);
    initReveal();
    initBento();
    syncThemeToggle();
    initBrandMoment();
    initSlides();
    if (window.matchMedia('(min-width:990px)').matches) $$('[data-foot-col]').forEach(function (d) { d.open = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function () { initPDP($('[data-pdp]')); $$('[data-auto-rail]').forEach(initAutoRail); initReveal(); initBento(); initBrandMoment(); initSlides(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-popup]')) open('WelcomePopup');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-popup]')) close();
  });
})();
